import React from 'react'

const Instructions = ({getQuestionAndResponses}) => {
    return (
        <div className="instructions__section__main in__quest">
            <h3>
                Instructions for Completing the Assessment
            </h3>
            <div className="instructions__section">
                <p>
                    Please review the following key terminology and guidelines before you begin to ensure a smooth and accurate assessment process.
                </p>
                <h4>
                    Terminology Clarification:
                </h4>
                <ul>
                    <li>
                        <span>"Building"</span> – Refers to the physical structure housing the coworking space.
                    </li>
                    <li>
                        <span>"Workspace Location/Location/Coworking"</span> – Refers specifically to the coworking facility or office within the building.
                    </li>
                </ul>
                <h4>
                    Assessment Structure
                </h4>
                <ul>
                    <li>
                        The assessment is divided into <span>eight categories</span>, each with a brief description to provide context on what is being assessed.
                    </li>
                    <li>
                        Within each category, you will find multiple assessment questions.
                    </li>
                </ul>
                <p>
                    Some questions do not contribute to the final assessment score or grade. These are marked as <span>“optional”</span> and are intended for data collection purposes. While you may skip these, they represent valuable insights sought by clients and brokers, so we encourage you to complete them if possible.
                </p>
                <div className="instruction__white__box">
                    <div className="white__box__header">
                        <h2>General Guidelines</h2>
                    </div>
                    <div className="white__box__body">
                        <h4>
                            Complete All Required Queries
                        </h4>
                        <ul>
                            <li>
                                All required questions must be answered. Required questions are marked with * on the left navigation menu bar.
                            </li>
                            <li>
                                If any required fields are left unanswered, the assessment will be considered incomplete and you will not be able to submit the assessment to be scored or graded.
                            </li>
                            <li>
                                Provide accurate and detailed responses to all inquiries
                            </li>
                        </ul>
                        <h4>
                            Additional Fields & Attachments
                        </h4>
                        <ul>
                            <li>
                                Try to provide complete and detailed responses in all <span>open-text fields.</span>
                            </li>
                            <li>
                                Include any <span>supporting documents</span> and information where possible.
                            </li>
                        </ul>
                        <h4>
                            Navigation
                        </h4>
                        <ul>
                            <li>
                                Use the <span>navigation bar</span> on the left to move between categories and questions.
                            </li>
                            <li>
                                Click the <span>"Main Page"</span> button to return to your location list, check progress, or switch to a different location.
                            </li>
                            <li>
                                After answering each question, click <span>"Next"</span> to save and proceed.
                            </li>
                            <li>
                                If unsure about an answer, you may skip it and revisit skipped questions later using the <span>"Go to Next Skipped Question"</span> button.
                            </li>
                        </ul>
                        <p>
                            Once you’ve reviewed the instructions, you’re ready to begin the assessment. Click "Next" to proceed.
                        </p>
                        <h4 className="mt-3">
                            Contact Us
                        </h4>
                        <p>
                            If you need any assistance, feel free to reach out to us at <a href="mailto:info@flexgrade.io">info@flexgrade.io</a>. We’ll get back to you within one business day.
                        </p>
                        <div className='next__and__skip'>
                            <button onClick={getQuestionAndResponses}>
                            NEXT
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Instructions